/**
 * Exterior 360 upload service – uses existing CarTest image flow.
 * For POC: creates 2 exterior images; order = creation order.
 * Future: backend adds frameIndex / 360-specific category.
 */
import { CarTestService } from "@/services/carTest/carTestService";
import type { ViewType360 } from "@/types/exterior360";

export class Exterior360Service {
  /**
   * Upload a single 360 frame as exterior image.
   * Uses frameIndex for ordering (backend stores it).
   */
  static async uploadFrame(
    carTestId: string,
    frameIndex: number,
    viewType: ViewType360,
    file: File
  ): Promise<{ id: string; url: string }> {
    const result = await CarTestService.addCarTestImage(
      carTestId,
      "exterior",
      file,
      false,
      undefined,
      undefined,
      frameIndex
    );
    return { id: result.id, url: result.url };
  }
}
